// extracted by mini-css-extract-plugin
module.exports = {"quizHolder":"Quiz_quizHolder__1JFml"};